import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';

const RemoveDestinationDialog = (props) => {
    const { removeDialog, setRemoveDialog, setMessage, setOpenLoadingSimpleBackdrop, fetchDestinations,
      setDestinations } = props;

    const handleCloseDialog = () => {
      setRemoveDialog((previousDialog) => ({
        ...previousDialog,
        open: false,
        agenda_id: null,
        mission_destination_id: null,
        mission_timesheet_destination_id: null,
        rowIndex: null,
      }));
    };

    const handleRemoveDestination = async () => {
      setOpenLoadingSimpleBackdrop(true);
      try {
        const timesheetDestinationId = removeDialog.mission_timesheet_destination_id;

        if (timesheetDestinationId != null) {
          const result = await TimeSheetMissionService.removeDestinationTimesheet(
            timesheetDestinationId
          );
          if (!result?.status) {
            throw new Error(
              result?.message || 'La suppression de la ligne a échoué.'
            );
          }

          if (typeof fetchDestinations === 'function') {
            await fetchDestinations();
          }
        } else {
          const hasRowIndex = removeDialog.rowIndex !== null &&
            removeDialog.rowIndex !== undefined;
          const rowIndex = Number(removeDialog.rowIndex);
          const hasValidRowIndex = hasRowIndex &&
            Number.isInteger(rowIndex) && rowIndex >= 0;
          const missionDestinationId = removeDialog.mission_destination_id;

          if (!hasValidRowIndex && missionDestinationId == null) {
            throw new Error('Impossible d’identifier la ligne à supprimer.');
          }

          setDestinations((previousDestinations = []) =>
            previousDestinations.filter((destination, index) => {
              if (hasValidRowIndex) {
                return index !== rowIndex;
              }

              return String(destination?.mission_destination_id) !==
                String(missionDestinationId);
            })
          );
        }

        setMessage({
          open: true,
          color: 'green',
          messageInfo: 'La ligne a été supprimée avec succès'
        });
      } catch (error) {
        setMessage({
          open: true,
          color: 'red',
          messageInfo: error.message || 'La suppression de la ligne a échoué.'
        });
      } finally {
        setOpenLoadingSimpleBackdrop(false);
        handleCloseDialog();
      }
    };

    return (
         <Dialog
                open={removeDialog.open}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="form-dialog-title" style={{ color: "white" }}>
                    {"Confirmation"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    { removeDialog.mission_timesheet_destination_id != null ? "Voulez-vous vraiment retirer cette ligne de destination ?" :
                     "Voulez-vous vraiment retirer cette ligne de destination ?  En confirmant, elle sera retirée du kilométrage mais restera enregistrée dans l’agenda de la mission."}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDialog} color="info" variant='outlined'>
                      Annuler
                    </Button>
                    <Button onClick={() => handleRemoveDestination()} color="error" autoFocus variant='contained'>
                      Confirmer
                    </Button>
                  </DialogActions>
                </Dialog>
    );
};

export default RemoveDestinationDialog;
